import {
  Avatar,
  Box,
  Button,
  InputAdornment,
  Typography,
} from "@mui/material";
import BreadCrumb from "app/components/BreadCrumb";
import { TextField } from "app/components/TextField";
import { EmailIcon, PasswordIcon, PhoneIcon, UserIcon } from "app/icons";
import React from "react";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ProfileField from "./components/ProfileField";
import ProfileSelect from "./components/ProfileSelect";
import ProfileSkeleton from "./components/ProfileSkeleton";
import { PROFILE_SELECT_FIELDS, useProfile } from "./hooks/useProfile";
import { profileSaga } from "./redux/saga";
import { reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const Profile = () => {
  const styles = useStyles();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: profileSaga,
  });

  const {
    t,
    i18n,
    profile,
    fullName,
    mobileNumber,
    setFullName,
    setMobileNumber,
    avatarInitials,
    showSkeleton,
    handleSaveProfile,
  } = useProfile();

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.PROFILE")} iconPosition="end" />

          {showSkeleton ? (
            <ProfileSkeleton />
          ) : (
            <Box className={styles.profileCard} dir={i18n.dir()}>
              <Box className={styles.avatarSection}>
                <Typography className={styles.fieldLabel}>
                  {t("PROFILE.AVATAR")}
                </Typography>
                <Avatar
                  className={styles.avatar}
                  {...(profile?.profilePic
                    ? { src: profile.profilePic }
                    : {})}
                >
                  {avatarInitials}
                </Avatar>
              </Box>

              <ProfileField
                label={t("PROFILE.FULL_NAME")}
                value={fullName}
                icon={<UserIcon className={styles.fieldIcon} />}
                readOnly={false}
                onChange={setFullName}
                onBlur={handleSaveProfile}
              />
              <ProfileField
                label={t("PROFILE.EMAIL")}
                value={profile?.email || ""}
                icon={<EmailIcon className={styles.fieldIcon} />}
              />
              <ProfileField
                label={t("PROFILE.PHONE_NUMBER")}
                value={mobileNumber}
                icon={<PhoneIcon className={styles.fieldIcon} />}
                readOnly={false}
                onChange={setMobileNumber}
                onBlur={handleSaveProfile}
              />

              <Box className={styles.passwordSection}>
                <Box className={styles.passwordRow}>
                  <Button
                    variant="outlined"
                    className={styles.changePasswordButton}
                  >
                    {t("PROFILE.CHANGE_PASSWORD")}
                  </Button>
                  <Box className={styles.passwordFieldWrapper}>
                    <Typography className={styles.fieldLabel}>
                      {t("AUTH.PASSWORD")}
                    </Typography>
                    <TextField
                      value={t("PROFILE.MOCK.MASKED_PASSWORD")}
                      type="password"
                      className={styles.textField}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <PasswordIcon className={styles.fieldIcon} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          <Box className={styles.preferencesCard} dir={i18n.dir()}>
            {PROFILE_SELECT_FIELDS.map((field) => (
              <ProfileSelect
                key={field.field}
                label={t(field.labelKey)}
                value={field.value}
                options={field.options.map((option) => ({
                  value: option.value,
                  label: t(option.labelKey),
                }))}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
